import React from 'react';
import styled from 'styled-components';

const CookieBannerDialogSectionRoot = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(8)};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export const CookieBannerDialogSection: React.FC<Props> = (props: Props) => {
  const { children } = props;

  return <CookieBannerDialogSectionRoot>{children}</CookieBannerDialogSectionRoot>;
};

export default React.memo(CookieBannerDialogSection);
